import React, { useState } from 'react'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Typography } from '@mui/material'
import { useTenantFormContext } from '../tenant-form-context'
import { useStyles } from './style'
import PagesList from './components/pages-management/pages-list'
import PageConfiguration from './components/pages-management/page-configuration'
import { PagesConfigSlice } from '../../../reducers'

const CMSTab = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { mainClasses, tenant } = useTenantFormContext()
  const [currentView, setCurrentView] = useState('pages-list') // 'pages-list' | 'page-config'
  const [currentPage, setCurrentPage] = useState(null)
  const pages = useSelector(PagesConfigSlice.selectors.selectPages)
  const [listPages, updatePage] = useEvent([PagesConfigSlice.eventBus.listPages, PagesConfigSlice.eventBus.updatePage])

  useEventsOnViewLoad(() => {
    if (pages.length === 0) {
      listPages.trigger({ tenantId: tenant.pk })
    }
  }, [listPages])

  const handlePageCreate = (pageData) => {
    dispatch(PagesConfigSlice.actions.createPage(pageData))
  }

  const handlePageEdit = (page) => {
    setCurrentPage(page)
    setCurrentView('page-config')
  }

  const handlePageDelete = (pageId) => {
    console.log('handlePageDelete', pageId)
  }

  const handleBackToPages = () => {
    setCurrentView('pages-list')
    setCurrentPage(null)
  }

  const handlePageUpdate = (updatedSections) => {
    updatePage.trigger({
      updatedSections,
      pageId: currentPage.pageId,
      tenantId: tenant.pk
    })
  }

  const renderCurrentView = () => {
    switch (currentView) {
      case 'page-config':
        return (
          <PageConfiguration
            page={currentPage}
            onBack={handleBackToPages}
            onPageUpdate={handlePageUpdate}
            isSaving={updatePage.isWorking}
          />
        )
      case 'pages-list':
      default:
        return (
          <Grid item xs={12}>
            <PagesList
              isLoading={listPages.isWorking}
              pages={pages}
              onPageCreate={handlePageCreate}
              onPageEdit={handlePageEdit}
              onPageDelete={handlePageDelete}
            />
          </Grid>
        )
    }
  }

  return (
    <Grid container className={classes.root}>
      {/* CMS Title - Only shown in pages list view */}
      {currentView === 'pages-list' && (
        <Grid container alignItems='center' className={mainClasses.ctnTitle}>
          <Grid item xs={8}>
            <Typography variant='h6'>CMS</Typography>
          </Grid>
        </Grid>
      )}

      {/* Render the current view (pages list or page configuration) */}
      {renderCurrentView()}
    </Grid>
  )
}

export default CMSTab
